import Controller from '@ember/controller';
import { inject as service } from '@ember/service';

import AlertsService from 'cio/services/alerts';
import SsoService from 'cio/services/sso';
import AccountService from 'cio/services/account';
import AnalyticsService from 'cio/services/analytics';
import FeaturesService from 'ember-feature-flags/services/features';
import AuthService from 'cio/services/auth';

export default class SettingsSecurityIndex extends Controller {
  @service account!: AccountService;
  @service alerts!: AlertsService;
  @service analytics!: AnalyticsService;
  @service features!: FeaturesService;
  @service sso!: SsoService;
  @service auth!: AuthService;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'settings/security/index': SettingsSecurityIndex;
  }
}
